export const builtInAvatars = []

export const builtInBackgrounds = []

export function getAvatarById(id) {
  return builtInAvatars.find((avatar) => avatar.id === id) || null
}

export function getBackgroundById(id) {
  return builtInBackgrounds.find((bg) => bg.id === id) || null
}
